import React from 'react'
import styled from 'styled-components'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'

import { Checkbox } from '../../../input'
import { Button } from '../../../buttons'
import { FONTS } from '../../../../constants'

export const PrivilegeRoleInfo = props => {
  const {
    emp,
    isEditRole,
    handleCheckbox,
    handleClickEdit,
    handleClickCancel,
    handleSavePrivilegeRole,
  } = props

  const is_hr_admin_confidential_role = localStorage.getItem('is_hr_admin_confidential_role') === 'true'
  const is_system_admin = localStorage.getItem('is_system_admin') === 'true'

  return (
    <Root>
      <Container>
        <FormGroup>
          <LabelRoleCol>
            <Label>Accounting</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_accountant_role_edit'
              name='is_accountant_role'
              disabled={ !isEditRole }
              checked={ emp.is_accountant_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Subcontractor</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_subcontract_role_edit'
              name='is_subcontract_role'
              disabled={ !isEditRole }
              checked={ emp.is_subcontract_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Manager</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_pm_role_edit'
              name='is_pm_role'
              disabled={ !isEditRole }
              checked={ emp.is_pm_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>LOB Lead</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_lob_lead_role_edit'
              name='is_lob_lead_role'
              disabled={ !isEditRole }
              checked={ emp.is_lob_lead_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Management</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_management_role_edit'
              name='is_management_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_management_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Admin</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_admin_role_edit'
              name='is_hr_admin_role'
              disabled={ !isEditRole }
              checked={ emp.is_hr_admin_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Admin Confidential</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_admin_confidential_role_edit'
              name='is_hr_admin_confidential_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_hr_admin_confidential_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>HR Subcontract</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_hr_subcontract_role_edit'
              name='is_hr_subcontract_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_hr_subcontract_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Display Standard Cost</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_vp_avp_role_edit'
              name='is_vp_avp_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_vp_avp_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Display PPS</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_display_pps_role_edit'
              name='is_display_pps_role'
              disabled={ !isEditRole }
              checked={ emp.is_display_pps_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Approver</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_project_approver_role_edit'
              name='is_project_approver_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_project_approver_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Project Acknowledge</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_project_acknowledge_role_edit'
              name='is_project_acknowledge_role'
              disabled={ !isEditRole || (!is_hr_admin_confidential_role && !is_system_admin) }
              checked={ emp.is_project_acknowledge_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Sales</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_salesman_role_edit'
              name='is_salesman_role'
              disabled={ !isEditRole }
              checked={ emp.is_salesman_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Submit Efficiency</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_submit_efficiency_role_edit'
              name='is_submit_efficiency_role'
              disabled={ !isEditRole }
              checked={ emp.is_submit_efficiency_role }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
        <FormGroup>
          <LabelRoleCol>
            <Label>Not Count Headcount</Label>
          </LabelRoleCol>
          <InputCol>
            <Checkbox
              id='is_not_count_headcount_edit'
              name='is_not_count_headcount'
              disabled={ !isEditRole }
              checked={ emp.is_not_count_headcount }
              onChange={ handleCheckbox }
            />
          </InputCol>
        </FormGroup>
      </Container>
      <Footer>
        <ButtonGroup>
          { isEditRole ?
            <ButtonGroup>
              <Button
                theme='#28a745'
                icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
                width='70px'
                height='26px'
                onClick={ () => handleSavePrivilegeRole(emp) }
              >
              Save
              </Button>
              <Button
                theme='#6c757d'
                width='70px'
                height='26px'
                onClick={ () => handleClickCancel(emp.user_id) }
              >
              Cancel
              </Button>
            </ButtonGroup>
            :
            <Button
              theme='#28a745'
              icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
              width='70px'
              height='26px'
              onClick={ () => handleClickEdit(3) }
            >
          Edit
            </Button>
          }
        </ButtonGroup>
      </Footer>
    </Root>
  )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const Container = styled.div`
    height: 100%;
    max-height: calc(100vh - 223px);
    padding: 16px 24px;
    background: #FFFFFF;
    overflow-y: scroll;
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelRoleCol = styled.div`
    display: flex;
    flex: 3;
`
const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Footer = styled.div`
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #F9F9F9;
    padding: 0 24px;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-last-child(1) {
      margin-left: 12px;
    }
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/privilege-role/index.js